import React, { useEffect, useState } from 'react'
import { Empty, Form, Radio } from 'antd'
import { Modal } from '@/components/dialog/modal'
import $msg from '@/utils/message'
import { IMember, IMemberLevelDetail } from '@/model/types/member'
import { resetMemberLevel } from '../api'

interface ChangeLevelForm {
    new_level: number
}

interface Props {
    visible: boolean
    member: IMember
    levels: IMemberLevelDetail[]
    onCancel: () => void
    onSuccess: () => void
}

const ChangeLevelModal: React.FC<Props> = props => {
    const [form] = Form.useForm<ChangeLevelForm>()
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (!props.visible) return

        form.resetFields()
    }, [form, props.visible])

    const availableLevels = props.levels.filter(level => level.level !== props.member.level?.level)

    const onSubmit = async () => {
        try {
            const values = await form.validateFields()
            setLoading(true)
            await resetMemberLevel({
                member_id: props.member.id,
                new_level: values.new_level,
            })
            $msg('success', '调整等级成功')
            props.onSuccess()
        } catch (e) {
            if (e && e.errorFields) return
            $msg('error', e.message || '调整等级失败')
        } finally {
            setLoading(false)
        }
    }

    return props.visible ? (
        <Modal
            title="调整会员等级"
            isShow
            type="success"
            loading={loading}
            disabled={!availableLevels.length}
            onConfirm={onSubmit}
            onClose={props.onCancel}
            onCancel={props.onCancel}
            okText="确认"
            cancelText="取消"
        >
            <div className="member-detail__modal-tip">
                当前等级：{props.member.level?.name || '-'}，成长值：{props.member.experience || 0}
            </div>
            <Form form={form} layout="vertical">
                <Form.Item name="new_level" label="调整为" rules={[{ required: true, message: '请选择会员等级' }]}>
                    {availableLevels.length ? (
                        <Radio.Group className="member-detail__level-options">
                            {availableLevels.map(level => (
                                <Radio key={level.id} value={level.level}>
                                    {level.name}
                                    <span className="member-detail__level-threshold">
                                        成长值不低于{level.experience_threshold}
                                    </span>
                                </Radio>
                            ))}
                        </Radio.Group>
                    ) : (
                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="暂无可调整的会员等级" />
                    )}
                </Form.Item>
            </Form>
        </Modal>
    ) : null
}

export default ChangeLevelModal
